import AudioPlayer from "./AudioPlayer";
import PlayButton from "./PlayButton";
import PauseButton from "./PauseButton";
import TogglePlayButton from "./TogglePlayButton";

export { PauseButton, PlayButton, TogglePlayButton };

export default AudioPlayer;
